// @flow

import { createPrqActions } from './createPrqActionCreator';

const initialState = {
  timeSlotList: [],
  captainList: [],
  suggestedCaptainId: null,
  selectedCaptainId: null,
  suggestedBPId: null,
  postCallInitiated: null,
  postCallCompleted: null,
  postCallFailureMsg: null,
  postCallData: null,
  existingPickupsFetching: null,
  existingPickups: null,
  fetchingPickupData: null,
  fetchedPickupData: null,
  pickupData: null,
  pickupFetchError: null,
  uuid: null,
  recentPickupsList: []
};

const createPrqReducer = (state: Object = initialState, action: Object) => {
  switch (action.type) {
    case createPrqActions.CREATE_PICKUP: {
      return Object.assign({}, state, action.payload);
    }
    case createPrqActions.GET_TIME_SLOTS: {
      return Object.assign({}, state, action.payload);
    }
    case createPrqActions.GET_SUGGESTED_CAPTAINS: {
      return Object.assign({}, state, action.payload);
    }
    case createPrqActions.GET_EXISTING_PICKUPS: {
      return Object.assign({}, state, action.payload);
    }
    case createPrqActions.GET_PICKUP_DATA: {
      return Object.assign({}, state, action.payload);
    }
    case createPrqActions.GET_RECENT_PICKUPS: {
      return Object.assign({}, state, action.payload);
    }
    default: {
      return state;
    }
  }
};

export default createPrqReducer;
